import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors } from '../../global';
import { media } from '../../services/media';
import { themeStyles } from '../../services/themeStyles';

const Upscore = themeStyles(
    'upscore',
    css`
        margin: 0 0 2em;
        line-height: 1.5;
        position: absolute;
        width: 100%;
        color: ${colors.black};

        ${media.max('lg')} {
            top: 120%;
            left: 0;
            right: 0;
        }

        ${media.min('lg')} {
            left: 75%;
            bottom: 0;
            max-width: 18vw;
        }

        &:after {
            content: '';

            display: block;

            width: 27px;
            height: 66px;

            position: absolute;
            top: -84px;
            right: 20%;

            background-image: url(/assets/images/upscore-arrow.svg);
            background-size: cover;

            ${media.min('lg')} {
                width: 50px;
                height: 117px;
                top: auto;
                right: calc(100% - 39px);
                bottom: -64px;
                background-image: url(/assets/images/upscore-arrow.svg);
                background-size: contain;
                background-repeat: no-repeat;
                transform: rotateY(180deg) rotateZ(91deg);
                opacity: 0.6;
            }

            ${media.min('lg')} {
                transform: rotateY(180deg) rotateZ(93deg);
                width: 80px;
                height: 141px;
                top: auto;
                right: calc(100% - 39px);
                bottom: -111px;
            }
        }
    `,
);

export const Message = styled.div`
    margin: 0 0 2em;
    line-height: 1.5;

    ${Upscore}
`;
